/**
 * Переключатель «нужна доставка / забор» одним нажатием — экран «Доставки» и вкладка «Доставка»
 * «Чатов». Включить — статус «Нужна доставка» («Нужен забор») и галка в договоре CRM, отменённую
 * роботом — вернуть прежний статус; выключить — «Отменили» и галку снять. **Пишет в боевой Bitrix
 * и договор CRM** (`POST /api/delivery/{сделка}/{start|end}`, право `delivery_edit`).
 */
import { useMutation } from "@tanstack/react-query";

import { type DeliveryEdit, type DeliveryResult, type Direction, saveDelivery } from "@/lib/delivery";

const LABEL: Record<Direction, [string, string]> = {
  start: ["доставка нужна", "доставка не нужна"],
  end: ["забор нужен", "забор не нужен"],
};

export function DeliveryNeed({
  deal,
  direction,
  on,
  guard = false,
  onSaved,
}: {
  deal: number;
  direction: Direction;
  /** Доставка сейчас нужна (активна). */
  on: boolean;
  /** Отменил робот — включение возвращает статус, что стоял до отмены. */
  guard?: boolean;
  onSaved: (r: DeliveryResult) => void;
}) {
  const m = useMutation({
    mutationFn: (body: DeliveryEdit) => saveDelivery(deal, direction, body),
    onSuccess: onSaved,
  });
  const label = LABEL[direction][on ? 0 : 1];
  return (
    <span className="inline-flex items-center gap-1.5 text-[12px]" data-annot={`переключатель: ${label}`}>
      <button
        type="button"
        role="switch"
        aria-checked={on}
        aria-label={label}
        title={on ? "Выключить: отменить в Bitrix и снять галку в договоре" : "Включить: поставить в Bitrix и галку в договоре"}
        disabled={m.isPending}
        onClick={() => m.mutate(on ? { need: false } : guard ? { restore: true } : { need: true })}
        className={`relative h-[16px] w-[28px] shrink-0 rounded-full transition-colors disabled:opacity-60 ${on ? "bg-ok" : "bg-fg-faint"}`}
      >
        <span className={`absolute top-[2px] h-[12px] w-[12px] rounded-full bg-white transition-[left] ${on ? "left-[14px]" : "left-[2px]"}`} />
      </button>
      <span className={on ? "text-fg" : "text-fg-muted"}>{m.isPending ? "записываю…" : label}</span>
      {m.isError && <span className="text-err">не записано: {m.error.message}</span>}
    </span>
  );
}
